import { render, staticRenderFns } from "./GrantorEmail.vue?vue&type=template&id=18ee6786&scoped=true&"
import script from "./GrantorEmail.vue?vue&type=script&lang=js&"
export * from "./GrantorEmail.vue?vue&type=script&lang=js&"
import style0 from "./GrantorEmail.vue?vue&type=style&index=0&id=18ee6786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee6786",
  null
  
)

export default component.exports